import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#217ee2',
        secondary: '#df970e',
        accent: '#790000',
        error: '#790000',
        info: '#217ee2',
        success: '#28ba0e',
        warning: '#df970e'
      },
      dark: {
        primary: '#217ee2',
        secondary: '#df970e',
        accent: '#790000',
        error: '#790000',
        info: '#217ee2',
        success: '#28ba0e',
        warning: '#df970e'
      }
    }
  }
})
